'use client'
import { Table, TableRow, TableHeader, TableCell, TextInput, TextInputUpperCase, TextArea, ColorButton, ReplyMessage, UserSearchInput } from "@/components/ui";
import { getClientSeller, updateClientSellerForm } from "@/app/api";
import { useActionState, useEffect, useState } from "react";
import { Smile, User, Text, IdCard, Contact } from "@/assets/icons";
import { useRouter } from "next/navigation";
import Form from "next/form";
import { clientSellerResponseType, defaultClientSeller, SearchUser } from "@/types";

export function UpdateClientSeller({ id }: { id: string }) {
    const [state, formAction, pending] = useActionState(updateClientSellerForm, {
        values: { id: id, clientCode: '', clientUserName: '', clientName: '', observation: '' },
        errors: {},
        message: '',
    })
    const [selectedClient, setSelectedClient] = useState<SearchUser | null>(null);

    const [clientSellerData, setClientSellerData] = useState<clientSellerResponseType>()

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await getClientSeller(id)
                if (response !== undefined) {
                    setClientSellerData(response)
                }
            } catch (e) {
                console.log('Não foi possível buscar o usuário: ', e)
            }
        }

        fetchUser()
    }, [id]);

    const clientSeller = clientSellerData || defaultClientSeller

    const handleClientSelect = (client: SearchUser) => {
        setSelectedClient(client);
    };

    const router = useRouter();
    if (state.success?.valueOf() === true) {
        setTimeout(() => {
            router.back();
        }, 1000);
    }

    return (
        <div>
            <div className="hidden md:flex">
                <Table>
                    <thead>
                        <TableRow>
                            <TableHeader>Código</TableHeader>
                            <TableHeader>Empresa</TableHeader>
                            <TableHeader>Nome</TableHeader>
                            <TableHeader>Data do Cadastro</TableHeader>
                            <TableHeader>Data da Atualização</TableHeader>
                        </TableRow>
                    </thead>
                    <tbody>
                        <TableRow>
                            <TableCell>{clientSeller.client.code}</TableCell>
                            <TableCell>{clientSeller.client.userName}</TableCell>
                            <TableCell>{clientSeller.client.name}</TableCell>
                            <TableCell>{new Date(clientSeller.createdAt).toLocaleDateString()}</TableCell>
                            {clientSeller.updatedAt === clientSeller.createdAt
                                ?
                                <TableCell> {"- - - - -"} </TableCell>
                                :
                                <TableCell>{new Date(clientSeller.updatedAt).toLocaleDateString()}</TableCell>
                            }
                        </TableRow>
                        <TableRow>
                            <TableHeader colSpan={1}>Observação</TableHeader>
                            <TableCell colSpan={3}>{clientSeller.observation}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>

            <div className="flex md:hidden">
                <Table>
                    <tbody>
                        <TableRow>
                            <TableHeader>Código</TableHeader>
                            <TableCell>{clientSeller.client.code}</TableCell>
                            <TableHeader>Empresa</TableHeader>
                            <TableCell>{clientSeller.client.userName}</TableCell>
                            <TableHeader>Nome</TableHeader>
                            <TableCell>{clientSeller.client.name}</TableCell>
                            <TableHeader>Data do Cadastro</TableHeader>
                            <TableCell>{new Date(clientSeller.createdAt).toLocaleDateString()}</TableCell>
                            <TableHeader>Data da Atualização</TableHeader>
                            {clientSeller.updatedAt === clientSeller.createdAt
                                ?
                                <TableCell> {"- - - - -"} </TableCell>
                                :
                                <TableCell>{new Date(clientSeller.updatedAt).toLocaleDateString()}</TableCell>
                            }
                            <TableHeader>Observação</TableHeader>
                            <TableCell>{clientSeller.observation}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>

            <Form action={formAction} className="flex flex-col gap-3">

                <input type="hidden" name="id" defaultValue={id} required />

                {/* Search Input */}

                <div className="flex gap-2 items-center">
                    <IdCard className="size-4" />
                    <div className="flex gap-1 items-baseline">
                        <label htmlFor="clientCode">Buscar Cliente</label>
                        <p className="text-xs">Selecione um cliente abaixo para preencher os campos automaticamente</p>
                    </div>
                </div>
                <UserSearchInput onSelectUser={handleClientSelect} userType={"client"} />

                {/* code of client */}

                <div className="flex gap-2 items-center">
                    <User className="size-4" />
                    <label htmlFor="clientCode">Código</label>
                </div>
                <TextInput name="clientCode" id="clientCode"
                    minLength={4} maxLength={4}
                    required
                    defaultValue={selectedClient?.code || state?.values?.clientCode}
                    placeholder="Código" />
                {state?.errors?.clientCode && <p>{state.errors.clientCode}</p>}

                {/* username of client */}

                <div className="flex gap-2 items-center">
                    <Contact className="size-4" />
                    <label htmlFor="clientUserName">Empresa</label>
                </div>
                <TextInputUpperCase name="clientUserName" id="clientUserName"
                    required
                    value={selectedClient?.userName || state?.values?.clientUserName}
                    placeholder="Empresa" />
                {state?.errors?.clientUserName && <p>{state.errors.clientUserName}</p>}

                {/* name of client */}

                <div className="flex gap-2 items-center">
                    <Smile className="size-4" />
                    <label htmlFor="clientName">Nome</label>
                </div>
                <TextInput name="clientName" id="clientName"
                    defaultValue={selectedClient?.name || state?.values?.clientName}
                    placeholder="Nome" />
                {state?.errors?.clientName && <p>{state.errors.clientName}</p>}

                {/* observation of client */}

                <div className="flex gap-2 items-center">
                    <Text className="size-4" />
                    <label htmlFor="observation">Observação</label>
                </div>
                <TextArea name="observation" id="observation"
                    defaultValue={clientSeller.observation || state?.values?.observation}
                    placeholder="Observação" />
                {state?.errors?.observation && <p>{state.errors.observation}</p>}

                {/* submit */}

                <div className="flex flex-col gap-3 p-4  items-center justify-center">
                    <ColorButton type="submit" disabled={pending}>
                        {pending ? 'Atualizando...' : 'Atualizar'}
                    </ColorButton>
                </div>

            </Form>
            <ReplyMessage message={state?.message || ""} />
        </div >
    )
}